import { DashboardDataGetters } from 'framework/ui/dashboard';
import { IssueStatus } from 'domain/shared/core/dashboard';
import { DashboardEmployee } from '../types';
import { RETENTION_RISK_ISSUE_STATUS } from '../constants';

const statusMap: Record<string, 'critical' | 'warning' | 'healthy'> = {
  CRITICAL: 'critical',
  ESCALATION: 'critical',
  MONITORING: 'warning',
};

const scoreMap: Record<string, number> = {
  CRITICAL: 25,
  ESCALATION: 25,
  MONITORING: 60,
};

const employeeDataGetters: DashboardDataGetters<DashboardEmployee> = {
  followUps: employee =>
    employee.retentionRiskFollowUps?.map(followUp => ({
      id: followUp.id,
      title: followUp.description,
      description: followUp.description,
      date: followUp.followUpDate,
      createdAt: followUp.createdAt,
      updatedAt: followUp.updatedAt,
    })),

  issues: employee =>
    employee.retentionRiskIssues?.map(issue => ({
      id: issue.id,
      title: issue.description,
      severity: issue.status === RETENTION_RISK_ISSUE_STATUS.ACTIVE ? 'high' : 'low',
      description: issue.description,
      status: issue.status === IssueStatus.ACTIVE ? 'open' : 'closed',
      createdAt: issue.createdAt,
    })),

  people: employee => {
    const people = [];

    if (employee.retentionRiskAssigneeAlias) {
      people.push({
        id: employee.retentionRiskAssigneeAlias,
        name: employee.retentionRiskAssigneeAlias,
        role: 'Assigned Manager',
      });
    }

    const mentor = employee.employeeMentor || employee.mentorshipInformation?.mentor;

    if (mentor) {
      people.push({
        id: mentor,
        name: mentor,
        role: 'Mentor',
      });
    }

    const uniquePeople = people.filter(
      (person, index, self) => index === self.findIndex(p => p.id === person.id && p.role === person.role),
    );

    return uniquePeople;
  },

  healthcheck: employee => {
    const priority = employee.retentionRiskPriority;
    if (!priority) return undefined;

    return {
      status: statusMap[priority] ?? 'healthy',
      score: scoreMap[priority] ?? 85,
      details: {
        'Retention Risk': priority,
        'Last Healthcheck': employee.retentionRiskLastHealthcheck || 'Never',
      },
    };
  },
};

export default employeeDataGetters;
